
  players = new Array();
  // create youtube player
      var player,iframe;
      function onYouTubePlayerAPIReady(videoId,tt) {
        if(window.innerHeight > window.innerWidth){
          var hheight = $( window ).height();
          var theight = $( window ).height() * (45 / 100 );
          var mtheight = $( window ).height() * (25 / 100 );
          var hheight = theight + 'px';
          var wwidth = $( window ).width();
          var twidth = $( window ).width() * (80 / 100 );
          var wwidth = twidth + 'px';
          $(".grtyoutube-popup-content").css("width",wwidth);
          $(".grtyoutube-popup-content").css("height",hheight);
          $(".grtyoutube-popup-content").css("margin-top",mtheight);
          $(".grtyoutube-popup-content iframe").css("width",wwidth);
          $(".grtyoutube-popup-content iframe").css("height",hheight);
        }else{
          var hheight = $( window ).height();
          var theight = $( window ).height() * (70 / 100 );
          var mtheight = $( window ).height() * (15 / 100 );
          var hheight = theight + 'px';
          var wwidth = $( window ).width();
          var twidth = $( window ).width() * (80 / 100 );
          var wwidth = twidth + 'px';
          $(".grtyoutube-popup-content").css("width",wwidth);
          $(".grtyoutube-popup-content").css("height",hheight);
          $(".grtyoutube-popup-content").css("margin-top",mtheight);
          $(".grtyoutube-popup-content iframe").css("width",wwidth);
          $(".grtyoutube-popup-content iframe").css("height",hheight);
        }
         player = new YT.Player('grtyoutube-iframe', {
          videoId: videoId,
          height: hheight,
          width: wwidth,
          events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerStateChange
          }
        });
        players.push(player);
        if($("#grtyoutube-iframe")[0].src){
         $("#grtyoutube-iframe")[0].src += "&modestbranding=0&showinfo=0&autohide=1&rel=0&control=0&iv_load_policy=3&nologo=1&enablejsapi=1&playsinline=1"; 
        iframe = $('#grtyoutube-iframe');
        if(window.innerHeight < window.innerWidth){
          var requestFullScreen = iframe.requestFullScreen || iframe.mozRequestFullScreen || iframe.webkitRequestFullScreen;
          if (requestFullScreen) {
            requestFullScreen.bind(iframe)();
          }
        } 
        }
        
      }

      // autoplay video
      function onPlayerReady(event) {
        event.target.playVideo();
      }

      // when video ends
      function onPlayerStateChange(event) { 
        console.log(players.length);
        if(event.data === 0) {          
          $(".grtyoutube-popup-close").trigger("click");
          for (var i = 0; i < players.length; i++) {
            var ptplayer = players[i].Y;
            if(ptplayer){
             $('#grtyoutube-iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
              players.pop();
            }

          }
        }
      }

      function onCloseAllPlayers(event){
        for (var i = 0; i < players.length; i++) {
          var ptplayer = players[i].Y;
          if(ptplayer){
           $('#grtyoutube-iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
             players.pop();
          }
        }
      }
  $( window ).resize(function() {
    if(window.innerHeight > window.innerWidth){
      var hheight = $( window ).height();
      var theight = $( window ).height() * (45 / 100 );
      var mtheight = $( window ).height() * (25 / 100 );
      var hheight = theight + 'px';
      var wwidth = $( window ).width();
      var twidth = $( window ).width() * (80 / 100 );
      var wwidth = twidth + 'px';
      $(".grtyoutube-popup-content").css("width",wwidth);
      $(".grtyoutube-popup-content").css("height",hheight);
      $(".grtyoutube-popup-content").css("margin-top",mtheight);
      $(".grtyoutube-popup-content iframe").css("width",wwidth);
      $(".grtyoutube-popup-content iframe").css("height",hheight);
    }else{
      var requestFullScreen = iframe.requestFullScreen || iframe.mozRequestFullScreen || iframe.webkitRequestFullScreen;
      if (requestFullScreen) {
        requestFullScreen.bind(iframe)();
      }
      var hheight = $( window ).height();
      var theight = $( window ).height() * (85/ 100 );
      var mtheight = $( window ).height() * (10 / 100 );
      var hheight = theight + 'px';
      var wwidth = $( window ).width();
      var twidth = $( window ).width() * (85 / 100 );
      var wwidth = twidth + 'px';
      $(".grtyoutube-popup-content").css("width",wwidth);
      $(".grtyoutube-popup-content").css("height",hheight);
      $(".grtyoutube-popup-content").css("margin-top",mtheight);
      $(".grtyoutube-popup-content iframe").css("width",wwidth);
      $(".grtyoutube-popup-content iframe").css("height",hheight);
    }
  });



$(".youtube-link").grtyoutube({
				autoPlay:true,
				theme: "dark"
			});
